import { productFactory } from './product.factory';
import { Portion } from '../model/portion.model';
import { Food } from '../model/food.model';
import { Weight } from '../model/weight.model';

export const foodFactory = {

  create(
      id,
      externalId,
      name,
      portions,
      parentId,
      hash,
      products,
      portion = null,
      recipe,
      tags = [],
      diets = [],
      equipments = [],
      meals = [],
      repeating = []) {
    if (!portion) {
      portion = new Portion(1);
    } else {
      portion = new Portion(portion.amount, new Weight(portion.weight.amount, portion.weight.unit));
    }

    return new Food(id, externalId, name, portions, parentId, hash, products, portion, recipe, tags, diets, equipments, meals, repeating);
  },

  createFromDto(foodDto, patient) {
    const products = foodDto.products.map(p => productFactory.createFromDto(p, patient));

    return this.create(
      foodDto.id,
      foodDto.externalId,
      foodDto.name,
      foodDto.portions,
      foodDto.parentId,
      foodDto.hash,
      products,
      foodDto.portion,
      foodDto.recipe,
      foodDto.tags,
      foodDto.diets,
      foodDto.equipments,
      foodDto.meals,
      foodDto.repeating
    );
  },
};
